import { render } from "./BubbleDraw1.vue?vue&type=template&id=46f67a4c&scoped=true"
import script from "./BubbleDraw1.vue?vue&type=script&lang=js"
export * from "./BubbleDraw1.vue?vue&type=script&lang=js"

import "./BubbleDraw1.vue?vue&type=style&index=0&id=46f67a4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f67a4c"]])

export default __exports__